import Vue from "vue";

import "./global-components";

import VueMask from "v-mask";
Vue.use(VueMask);

import VTooltip from "v-tooltip";
import "@/scss/tooltip.scss";
Vue.use(VTooltip);
